import React from 'react';
import {
	Box,
	Button,
  Typography,
} from '@mui/material';
import MainTemplate from '../templates/MainTemplate';

function HomeView({ viewParameters, mdUpScreen, handleNavigate, templateRef }) {

  const { estilos } = viewParameters;

  return (
    <MainTemplate templateRef={templateRef} view={viewParameters}>
      <Box sx={{ height: mdUpScreen ? '25%' : '20%' }} />
      {viewParameters?.mensaje && (<Typography sx={viewParameters.estilos.cuerpo}>
        {viewParameters.mensaje}
      </Typography>)}
      <Button variant="contained" fullWidth={false} sx={estilos.boton} onClick={() => handleNavigate('/login')}>Ingresar</Button>           
    </MainTemplate>
  );
}



export default HomeView;
